import type { constants } from "./constants";
import { getDomain } from "./getDomain";

type ENV = typeof constants.APPS.DESKTOP.ENV;

/**
 * Returns current environment, based on url domain
 * @returns system environment
 */
export function getENV(): keyof ENV {
  const domain = getDomain();

  switch (domain) {
    case "akitabox.com":
      return "PRODUCTION";

    case "beta-abx.com":
      return "BETA";

    case "test-abx.com":
      return "TEMP";

    default:
      return "LOCAL";
  }
}
